import type React from 'react';
import { useEffect, useState } from 'react';

export const useParentElement = (ref: React.RefObject<HTMLElement>) => {
  const [parent, setParent] = useState<ParentNode | null>(ref.current);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (ref.current) setParent(ref.current.parentNode);
  });
  return parent;
};
